import { useNavigate } from 'react-router-dom';
import { useCallback } from 'react';

const useAsyncNavigate = () => {
  const navigate = useNavigate();

  return useCallback(
    async (navigationObject) => {
      let resolved = false;
      const originalLocation = window.location.href;

      navigate(navigationObject);

      await new Promise((resolve) => {
        const checkNavigation = () => {
          const currentLocation = window.location.href;
          if (!resolved && currentLocation !== originalLocation) {
            resolved = true;
            window.removeEventListener('popstate', checkNavigation);
            resolve();
          }
        };

        window.addEventListener('popstate', checkNavigation);
        setTimeout(() => {
          checkNavigation();
          if (!resolved) {
            resolved = true;
            window.removeEventListener('popstate', checkNavigation);
            resolve();
          }
        }, 500);
      });
    },
    [navigate]
  );
};

export default useAsyncNavigate;
